import React from 'react';

import toast from 'react-hot-toast';
import { FaPhone, FaWhatsapp } from 'react-icons/fa';

import Service from 'interfaces/Service';

import { TwoNumberContainer, WhatsappButton, PhoneBoxButton } from './styles';

interface PhoneDetailsProps {
  service: Service;
}

const PhoneDetails: React.FC<PhoneDetailsProps> = ({ service }) => {
  const copyToClipboard = async (text: string): Promise<void> => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success('Telefone copiado para a área de transferência');
    });
  };

  return (
    <>
      {service.cellphones.length > 0 && service.phones.length > 0 ? (
        <TwoNumberContainer>
          <WhatsappButton number={`5521${service.cellphones[0]}`}>
            <FaWhatsapp size={25} />
            {service.cellphones[0]}
          </WhatsappButton>
          <div style={{ width: '15px' }} />
          <PhoneBoxButton onClick={() => copyToClipboard(service.phones[0])}>
            <FaPhone size={25} />
            {service.phones[0]}
          </PhoneBoxButton>
        </TwoNumberContainer>
      ) : service.cellphones.length > 0 && service.phones.length === 0 ? (
        <WhatsappButton number={`5521${service.cellphones[0]}`}>
          <FaWhatsapp size={30} />
          {service.cellphones[0]}
        </WhatsappButton>
      ) : service.phones.length > 0 && service.cellphones.length === 0 ? (
        <PhoneBoxButton onClick={() => copyToClipboard(service.phones[0])}>
          {service.phones[0]}
        </PhoneBoxButton>
      ) : (
        <p>Este profissional não tem um número cadastrado</p>
      )}
    </>
  );
};

export default PhoneDetails;
